import { render } from "./matching-card-compact-wrapper.vue?vue&type=template&id=75c70f66&scoped=true&ts=true"
import script from "./matching-card-compact-wrapper.vue?vue&type=script&lang=ts"
export * from "./matching-card-compact-wrapper.vue?vue&type=script&lang=ts"

import "./matching-card-compact-wrapper.vue?vue&type=style&index=0&id=75c70f66&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75c70f66"]])

export default __exports__